import { pickListPt } from '@/PrimeVue/themePreset/passThrough/pickListConfiguration';
import { datePickerPt } from '@/PrimeVue/themePreset/passThrough/datePickerConfiguration';
import { autocompletePt } from '@/PrimeVue/themePreset/passThrough/autocompleteConfiguration';
import { listboxPt } from '@/PrimeVue/themePreset/passThrough/listboxConfiguration';
import { textareaPt } from '@/PrimeVue/themePreset/passThrough/textareaConfiguration';

export default {
  picklist: pickListPt,
  datepicker: datePickerPt,
  autocomplete: autocompletePt,
  listbox: listboxPt,
  textarea: textareaPt
};